import { request } from '../../utils/axios';

const examPrefix = '/exam';

// 获取试卷列表
export const getExamRuleList = async (params) => {
  return request.get(`${examPrefix}/rule/getActive`, { params });
};
// 生成试卷内容
export const generateExamContent = async (data) => {
  return request.post(`${examPrefix}/paper/generate`, data);
};
// 获取我的考试记录
export const getMyExamRecord = async (params) => {
  return request.get(`${examPrefix}/record/myList`, { params });
};
// 获取我的考试记录详情
export const getMyExamRecordDetail = async (params) => {
  return request.get(`${examPrefix}/record/result`, { params });
};
// 保存答题记录及答案
export const saveAnswer = async (data) => {
  return request.post(`${examPrefix}/paper/saveAnswer`, data);
};
// 提交考试
export const submitExam = async (data) => {
  return request.post(`${examPrefix}/paper/submit`, data);
};
